import PubSub from 'pubsub-js';
export { default as PubSub } from 'pubsub-js';
import { useCallback, useEffect, useState } from 'react';
import debounce from 'debounce';

var useSubscribe = function (_a) {
    var token = _a.token, handler = _a.handler, _b = _a.isUnsubscribe, isUnsubscribe = _b === void 0 ? false : _b;
    var unsubscribe = useCallback(function () {
        PubSub.unsubscribe(token);
    }, [token]);
    var resubscribe = useCallback(function () {
        PubSub.unsubscribe(token);
        PubSub.subscribe(token, handler);
    }, [token, handler]);
    useEffect(function () {
        if (isUnsubscribe) {
            unsubscribe();
        }
        else {
            PubSub.subscribe(token, handler);
        }
        return function () {
            unsubscribe();
        };
    }, [isUnsubscribe]);
    return { unsubscribe: unsubscribe, resubscribe: resubscribe };
};

var usePublish = function (_a) {
    var token = _a.token, message = _a.message, _b = _a.isAutomatic, isAutomatic = _b === void 0 ? false : _b, _c = _a.isInitialPublish, isInitialPublish = _c === void 0 ? false : _c, _d = _a.isImmediate, isImmediate = _d === void 0 ? false : _d, _e = _a.debounceMs, debounceMs = _e === void 0 ? 300 : _e;
    var _f = useState(false), lastPublish = _f[0], setLastPublish = _f[1];
    var publish = useCallback(function () {
        var isPublished = PubSub.publish(token, message);
        setLastPublish(isPublished);
    }, [token, message]);
    useEffect(function () {
        if (isInitialPublish) {
            publish();
        }
    }, []);
    useEffect(function () {
        var debouncedPublished = debounce(publish, +debounceMs, isImmediate);
        if (isAutomatic && message) {
            debouncedPublished();
        }
        return function () {
            debouncedPublished.clear();
        };
    }, [publish, isImmediate, isAutomatic, debounceMs]);
    return { lastPublish: lastPublish, publish: publish };
};

var index = { PubSub: PubSub, useSubscribe: useSubscribe, usePublish: usePublish };

export default index;
export { usePublish, useSubscribe };
//# sourceMappingURL=index.es.js.map
